import i18next from 'i18next';
import { ParentClinicOption } from 'infrastructure/enums/parent-clinic';

export interface IParentClinicItem {
  id: ParentClinicOption | null | 'All';
  name: string;
}

export const parentClinicsDataSource = (): IParentClinicItem[] => {
  return [
    {
      id: null,
      name: i18next.t('labels.all'),
    },
    {
      id: ParentClinicOption.ParentClinics,
      name: i18next.t('labels.parentClinics'),
    },
  ];
};
